// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiPricingPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import {
  BodyHermesCO,
  BodyHermesMX,
  HermesMessageCO,
  HermesMessageMX,
  HermesResponseCO,
  HermesResponseMX,
} from '../interfaces/interfaces';

export const saveHermes = apiPricingPortal.injectEndpoints({
  endpoints: builder => ({
    saveHermes: builder.mutation({
      query: (hermesFormData: BodyHermesCO | BodyHermesMX | null) => ({
        body: hermesFormData,
        method: 'PUT',
        url: '/change_coordinates',
      }),
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'saveHermes',
        };
        return modelError;
      },
      transformResponse: (
        response: HermesResponseCO | HermesResponseMX
      ): HermesMessageMX | HermesMessageCO => {
        const hermesResponse: HermesMessageMX | HermesMessageCO =
          response?.message as HermesMessageMX | HermesMessageCO;

        return hermesResponse;
      },
    }),
  }),
});

export const { useSaveHermesMutation } = saveHermes;
